// extracted by css-extract-rspack-plugin
var _1 = "xl";
var _2 = "xm";
var _3 = "xw";
var _4 = "o";
var _5 = "n";
var _6 = "xr";
var _7 = "f0";
var _8 = "xp";
var _9 = "xt";
var _a = "xq";
var _b = "wc";
var _c = "hp";
var _d = "uu";
var _e = "xk";
var _f = "xv";
var _10 = "xu";
var _11 = "x0";
var _12 = "xz";
var _13 = "xn";
var _14 = "xo";
var _15 = "xx";
var _16 = "xs";
var _17 = "x2";
var _18 = "x4";
var _19 = "x3";
var _1a = "xy";
var _1b = "x6";
var _1c = "x5";
var _1d = "x1";
var _1e = "x7";
export { _1 as "blue", _2 as "blueBig", _3 as "blueRound", _4 as "button", _5 as "buttonComponent", _6 as "buttonWithIcon", _7 as "disabled", _8 as "grey", _9 as "greyBlue", _a as "greyBlueRound", _b as "lightBlue", _c as "lightBlueBig", _d as "magenta", _e as "magentaBig", _f as "magentaRound", _10 as "magentaRoundSmall", _11 as "primaryBlue", _12 as "primaryMagenta", _13 as "red", _14 as "redBig", _15 as "redRound", _16 as "roundIcon", _17 as "roundText", _18 as "transparentLightBlue", _19 as "transparentMagenta", _1a as "transparentRound", _1b as "transparentRoundMagentaBorder", _1c as "transparentRoundMagentaBorderSmall", _1d as "whiteBlack", _1e as "whiteToastedYellowBlack" }
